<template>
  <span class="icon" @click="click">
    <i class="fas" :class="{ [name]: true, 'fa-fw': fw }"></i>
  </span>
</template>

<script>
export default {
  name: "icon",

  props: {
    name: String,
    fw: Boolean
  },

  methods: {
    click() {
      this.$emit("click");
    }
  }
};
</script>

<style></style>
